module.exports = __webpack_public_path__ + "img/screen-manual-9.f2cd2e4c.png";